import React from 'react'
import { Link } from 'react-router-dom'
export default function Footer() {
   const top = ()=>{
      window.scrollTo({ top: 0, });
  };


  return (
    <>   <footer>
    <div className="footer-area pt-100">
       <div className="container">
          <div className="footer-main mb-60">
             <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                   <div className="footer-widget f-w1 mb-40">
                      <div className="footer-img">
                         <Link to="/"> <img src="assets\img\slider\TECH-O-ZONE (1).jpg" alt="footer-logo"/></Link>
                         <p>25, Akshat Nagar, near Industrial Area, Balgarh, Balaji Nagar, Dewas, Madhya Pradesh 455001</p>
                      </div>
                      <div className="footer-icon">
                         <Link to="https://www.facebook.com/profile.php?id=100086700827802" target='_blank'><i className="fab fa-facebook-f"></i></Link>
                         <Link to="https://wa.me/9617124507" target='_blank'><i className="fab fa-whatsapp fa-lg"></i></Link>
                         <Link to="https://www.instagram.com/techozone1971/" target='_blank'><i className="fab fa-instagram"></i></Link>
                         <Link to="https://www.linkedin.com/company/tech-o-zone/" target='_blank'> <i className="fab fa-linkedin-in"></i></Link>
                      </div>
                   </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                   <div className="footer-widget f-w2 mb-40">
                      <h3>Development</h3>
                      <ul>
                         <li onClick={()=>top()}><Link to="/Development">Wordpress</Link></li>
                         <li onClick={()=>top()}><Link to="/Development"> C & C++</Link></li>
                         <li onClick={()=>top()}><Link to="/Development">Javascript & jquery</Link></li>
                         <li onClick={()=>top()}><Link to="/Development">MySQL & PHP</Link></li>
                      
                   
                      
                      </ul>
                   </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                   <div className="footer-widget f-w3 mb-40">
                      <h3>Browse Courses</h3>
                      <ul>
                         <li onClick={()=>top()} ><Link to="/Development">Development</Link></li>
                         <li onClick={()=>top()}><Link to="/Markteing">Markteing</Link></li>
                      
                      </ul>
                   </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                   <div className="footer-widget f-w4 mb-40">
                      <h3>Insight Community</h3>
                      <ul>
                         <li ><Link to="#">Global Partners</Link></li>
                         <li><Link to="#">Forum</Link></li>
                         <li><Link to="#">Help & Support</Link></li>
                         <li><Link to="#">Community</Link></li>
                         <li><Link to="#">Documentation</Link></li>
                      </ul>
                   </div>
                </div>
             </div>
          </div>
          <div className="copyright-area">
             <div className="container">
                <div className="row">
                   <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div className="copyright-text ">
                         <p>Copyright © 2023 <span>Tech O Zone </span> </p>
                      </div>
                   </div>
                   <div className="col-xl-6 col-lg-6 col-sm-6">
                      <div className="copy-right-support ">
                         <div className="copy-right-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="43.945" height="50"
                               viewBox="0 0 43.945 50">
                               <g id="headphones" transform="translate(-31)">
                                  <g id="Group_2171" data-name="Group 2171" transform="translate(36.859 20.508)">
                                     <g id="Group_2170" data-name="Group 2170">
                                        <path id="Path_2983" data-name="Path 2983"
                                           d="M95.395,210A4.4,4.4,0,0,0,91,214.395v11.914a4.395,4.395,0,1,0,8.789,0V214.395A4.4,4.4,0,0,0,95.395,210Z"
                                           transform="translate(-91 -210)" fill="#2467ec" />
                                     </g>
                                  </g>
                                  <g id="Group_2173" data-name="Group 2173" transform="translate(31 23.669)">
                                     <g id="Group_2172" data-name="Group 2172">
                                        <path id="Path_2984" data-name="Path 2984"
                                           d="M33.93,243.6a7.268,7.268,0,0,1,.125-1.234A4.386,4.386,0,0,0,31,246.529v6.055a4.386,4.386,0,0,0,3.054,4.163,7.268,7.268,0,0,1-.125-1.234Z"
                                           transform="translate(-31 -242.366)" fill="#2467ec" />
                                     </g>
                                  </g>
                                  <g id="Group_2175" data-name="Group 2175" transform="translate(48.578 20.508)">
                                     <g id="Group_2174" data-name="Group 2174">
                                        <path id="Path_2985" data-name="Path 2985"
                                           d="M227.113,210a4.4,4.4,0,0,0-4.395,4.395v11.914a4.4,4.4,0,0,0,4.395,4.395,4.335,4.335,0,0,0,1.259-.206,4.386,4.386,0,0,1-4.189,3.136h-4.664a4.395,4.395,0,1,0,0,2.93h4.664a7.333,7.333,0,0,0,7.324-7.324V214.395A4.4,4.4,0,0,0,227.113,210Z"
                                           transform="translate(-211 -210)" fill="#2467ec" />
                                     </g>
                                  </g>
                                  <g id="Group_2177" data-name="Group 2177" transform="translate(71.891 23.669)">
                                     <g id="Group_2176" data-name="Group 2176">
                                        <path id="Path_2986" data-name="Path 2986"
                                           d="M449.722,242.366a7.266,7.266,0,0,1,.125,1.234v11.914a7.266,7.266,0,0,1-.125,1.234,4.386,4.386,0,0,0,3.055-4.163v-6.055A4.386,4.386,0,0,0,449.722,242.366Z"
                                           transform="translate(-449.722 -242.366)" fill="#2467ec" />
                                     </g>
                                  </g>
                                  <g id="Group_2179" data-name="Group 2179" transform="translate(31)">
                                     <g id="Group_2178" data-name="Group 2178">
                                        <path id="Path_2987" data-name="Path 2987"
                                           d="M52.973,0A22,22,0,0,0,31,21.973v.037a7.253,7.253,0,0,1,3-1.361,19.02,19.02,0,0,1,37.952,0,7.256,7.256,0,0,1,3,1.361v-.037A22,22,0,0,0,52.973,0Z"
                                           transform="translate(-31)" fill="#2467ec" />
                                     </g>
                                  </g>
                               </g>
                            </svg>
                         </div>
                         <div className="copyright-svg-content">
                            <p>Have a question? Call us 24/7</p>
                            <h5><Link to="tel:9617124507">(+91) 9617124507</Link></h5>
                         </div>
                      </div>
                   </div>
               
                </div>
             </div>
          </div>
       </div>
    </div>
 </footer>
 

 
 <div className="progress-wrap">
    <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
       <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
 </div>
 </>
  )
}
